export enum Status {
    InProgress = "In Progress",
    Denied = "Denied",
    Completed = "Completed",
}